import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Chip, ChipSize, ChipVariant } from '@enbw/ui-react'
import { ContractStatus } from '@/pages/ContractSearchPage/types'

type ContractStatusLabelProps = {
  readonly status: ContractStatus
  readonly size?: ChipSize
}

export const ContractStatusLabel: FC<ContractStatusLabelProps> = ({ status, size = ChipSize.Small }) => {
  const { t } = useTranslation()

  const getStatusLabel = (status: ContractStatus): string => {
    switch (status) {
      case ContractStatus.Active:
        return t('contracts.status.active')
      case ContractStatus.InTermination:
        return t('contracts.status.inTermination')
      case ContractStatus.Terminated:
        return t('contracts.status.terminated')
      default:
        return t('contracts.status.active')
    }
  }

  const getStatusVariant = (status: ContractStatus): ChipVariant => {
    switch (status) {
      case ContractStatus.Active:
        return ChipVariant.FeedbackSuccess
      case ContractStatus.InTermination:
        return ChipVariant.FeedbackWarning
      case ContractStatus.Terminated:
        return ChipVariant.FeedbackError
      default:
        return ChipVariant.FeedbackSuccess
    }
  }

  return <Chip size={size} label={getStatusLabel(status)} variant={getStatusVariant(status)} />
}
